import React, { useEffect, useRef, useState } from "react";
import "./fleet-management.scss";
import {
  Button,
  Space,
  Card,
  Tag,
  Row,
  Col,
  Typography,
  Spin,
  Input,
  Tabs,
  Modal,
} from "antd";
import MapButtonIconTrukker from "../../assets/images/maps-square-button.svg";
import MapButtonIconAdeed from "../../assets/adeed/images/maps-square-button.svg";
import clockImg from "../../assets/images/clock-01.svg";
import currentLocation from "../../assets/images/current-location-img.svg";
import movingCircle from "../../assets/images/moving-circle-arrow-reload.svg";
import TruckWithBoxTrukker from "../../assets/images/truck-with-box.svg";
import TruckWithBoxAdeed from "../../assets/adeed/images/truck-with-box.svg";
import TruckWithGrillTrukker from "../../assets/images/Grill-truck.svg";
import TruckWithGrillAdeed from "../../assets/adeed/images/Grill-truck.svg";
import EmptyTruckTrukker from "../../assets/images/Flatted-truck.svg";
import EmptyTruckAdeed from "../../assets/adeed/images/Flatted-truck.svg";
import TruckNumImg from "../../assets/images/truck-num-img.svg";
import TruckPhoneImg from "../../assets/images/phone-img.svg";
import NodataImgTrukker from "../../assets/images/nodata-img.svg";
import NodataImgAdeed from "../../assets/adeed/images/nodata-img.svg";
import NextArrowGrey from "../../assets/images/arrow-right-grey.svg";
import NextArrowGreen from "../../assets/images/arrow-right-green.svg";
import NextArrowOrangeTrukker from "../../assets/images/arrow-right-orange.svg";
import NextArrowOrangeAdeed from "../../assets/adeed/images/arrow-right-orange.svg";
import DriverGruardImg from "../../assets/images/driver-guard-img.svg";
import SupplierdImg from "../../assets/images/supplier-user-icon.svg";
import LoadingImg from "../../assets/images/loading-02.svg";
import StudentCardImg from "../../assets/images/student-card-fleet-driver.svg";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import AddTruck from "./add-truck";
import AddDriver from "./add-driver";
import * as driverService from "../../service/fleet-management/driverService";
import * as truckService from "../../service/fleet-management/truckService";
import * as supplierService from "../../service/fleet-management/supplierService";
import * as fleetTrackService from "../../service/fleet-management/fleetTrackService";
import Notification from "../../service/notification";
import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/store";
import { checkIsInternalSourcing } from "../../util/constantUtility";
import { checkIsSTO } from "../../util/constantUtility";
import moment from "moment";
import CustomMapModal from "./map-view-modal";


import fileSearchGif from "../../../src/assets/images/file-search.gif";
import SampleDocumentPreviewModal from "../login/sign-up/components/sample-documents-view";
import { isAdeed } from "../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const MapButtonIcon = isAdeed ? MapButtonIconAdeed : MapButtonIconTrukker;
const TruckWithBox = isAdeed ? TruckWithBoxAdeed : TruckWithBoxTrukker;
const TruckWithGrill = isAdeed ? TruckWithGrillAdeed : TruckWithGrillTrukker;
const EmptyTruck = isAdeed ? EmptyTruckAdeed : EmptyTruckTrukker;
const NodataImg = isAdeed ? NodataImgAdeed : NodataImgTrukker;
const NextArrowOrange = isAdeed ? NextArrowOrangeAdeed : NextArrowOrangeTrukker;

const { Text } = Typography;
const { TabPane } = Tabs;

export const initialUploadState = {
  progress: 0,
  status: "Hold Tight - File is Being Prepared Securely.",
  description: "Please don’t close or refresh the screen",
  started: false,
};

const Fleet = ({}) => {
  const { t } = useTranslation();
  let { supplierId, supplierName } = useParams();
  const { user, saveUser } = useStore();
  const location = useLocation();
  const [fleetType, setFleetType] = useState("Trucks");
  const [trackingType, setTrackingtype] = useState("onTrip");
  const [currentTab, setCurrentTab] = useState("All");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trucks, setTrucks] = useState([]);
  console.log("trucks", trucks);
  const [drivers, setDrivers] = useState([]);
  console.log("drivers", drivers);
  const navigate = useNavigate();
  const [pageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [hasMoreData, setHasMoreData] = useState(true);
  const [supplierData, setSupplierData] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [onTripTrackList, setOnTripTrackList] = useState([]);
  const [availableTrackList, setAvailableTrackList] = useState([]);
  const [mapModalOpen, setMapModalOpen] = useState(false);

  // Refs for optimization
  const observerRef = useRef();
  const searchTimeoutRef = useRef(null);
  const isInitialLoadRef = useRef(true);
  const isDataLoadingRef = useRef(false);

  // OCR SCREENS states
  const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);
  const [uploadState, setUploadState] = useState(initialUploadState);
  const [countryCodeName, setCountryCodeName] = useState("");

  // Sample Doc Preview Modal states
  const [isSamplePreviewOpen, setSamplePreviewOpen] = useState(false);
  const [sampleType, setSampleType] = useState("");

  // Initial data load
  useEffect(() => {
    const loadInitialData = async () => {
      if (!isInitialLoadRef.current) return;
      setLoading(true);
      isInitialLoadRef.current = false;

      try {
        if (checkIsInternalSourcing(user?.userRole)) {
          await getSupplierData();
        } else {
          getOnTripTruckTrackingList();
          getAvailableTruckTrackingList();
          await getData();
        }
      } catch (error) {
        console.error("Error loading initial data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

  // Handle data fetching for trucks/drivers
  useEffect(() => {
    if (!loading && !isInitialLoadRef.current && !isDataLoadingRef.current) {
      getData();
    }
  }, [currentPage, fleetType, currentTab]);

  // Handle search with debounce
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setCurrentPage(1);
      setHasMoreData(true);
      if (fleetType === "Trucks") {
        setTrucks([]);
      } else {
        setDrivers([]);
      }
      getData();
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchValue]);

  // Intersection Observer for infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          hasMoreData &&
          !loading &&
          !isDataLoadingRef.current
        ) {
          setCurrentPage((prev) => prev + 1);
        }
      },
      { threshold: 0.1 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) observer.unobserve(observerRef.current);
    };
  }, [hasMoreData, loading]);

  const handleCloseModal = () => {
    setAddModalOpen(false);
  };

  const getData = async () => {
    if (loading || isDataLoadingRef.current) return;

    isDataLoadingRef.current = true;
    setLoading(true);
    try {
      let response;
      let payload = {
        pageSize,
        pageNumber: currentPage,
        supplierId: supplierId || "",
        searchText: searchValue,
        status: currentTab === "All" ? null : currentTab,
      };

      if (fleetType === "Drivers") {
        response = await driverService.getAllDriver(payload);
        if (response.status === 200) {
          if (searchValue || currentPage === 1) {
            setDrivers(response?.data?.data);
          } else {
            setDrivers((prev) => [...prev, ...response?.data?.data]);
          }
          setHasMoreData(
            response.data.pagination.pageNumber <
              response.data.pagination.totalPages
          );
        }
      } else {
        response = await truckService.getAlltruck(payload);
        if (response.status === 200) {
          if (searchValue || currentPage === 1) {
            setTrucks(response?.data?.data);
          } else {
            setTrucks((prev) => [...prev, ...response?.data?.data]);
          }
          setHasMoreData(
            response.data.pagination.pageNumber <
              response.data.pagination.totalPages
          );
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMoreData(false);
    } finally {
      setLoading(false);
      isDataLoadingRef.current = false;
    }
  };

  const truckCard = (truck, index) => {
    return (
      <Col span={12} key={index}>
        <div
          className="left-card"
          onClick={() => {
            checkIsInternalSourcing(user?.userRole)
              ? navigate(
                  `/fleet-management/truck-${truck.truckId}/${supplierId}/${truck.assetPlateNumber}`
                )
              : navigate(
                  `/fleet-management/truck-${truck.truckId}/${truck.assetPlateNumber}`
                );
          }}
        >
          <Row>
            <div>
              <Space className="country-detail">
                <span className="country-name">
                  {truck?.countryFlagPath && (
                    <img
                      src={truck.countryFlagPath}
                      className="img-country-flag-class"
                    />
                  )}
                  <span>{truck.registrationCountryCode}</span>
                </span>
                <Text style={{ width: "200px" }} ellipsis={{ tooltip: true }}>
                  {truck?.assetPlateNumber}
                </Text>
              </Space>
            </div>
            <span
              className={
                truck.statusText === "Available"
                  ? "available-status"
                  : "warning-status"
              }
            >
              {truck?.statusText}
            </span>
          </Row>
          <Row>
            <span className="country-type-truck">{truck?.truckType}</span>
            <img src={truck?.truckFilePath} alt="alt" className="img-size" />
          </Row>
          <div className="last-update">
            <Text
              className="typo-text"
              style={{ width: "14rem" }}
              ellipsis={{ tooltip: true }}
            >
              {truck?.actionableMessage
                ? truck?.actionableMessage
                : "No Action Required"}
            </Text>
            {truck?.actionableMessage && (
              <img
                src={
                  truck.tripStatus === "Trip was recently completed"
                    ? NextArrowGreen
                    : NextArrowGrey
                }
                alt="alt"
              />
            )}
          </div>
        </div>
      </Col>
    );
  };

  const driverCard = (driver, index) => {
    return (
      <Col span={12} key={index}>
        <div
          className="left-card-driver"
          onClick={async () => {
            // checkIsInternalSourcing(user?.userRole) ?
            // navigate(`/fleet-management/driver-${driver.driverId}/${supplierId}/${driver.name}`):
            // navigate(`/fleet-management/driver-${driver.driverId}/${driver.name}`)
            const path = checkIsInternalSourcing(user?.userRole)
              ? `/fleet-management/driver-${driver.driverId}/${supplierId}/${driver.name}`
              : `/fleet-management/driver-${driver.driverId}/${driver.name}`;

            navigate(path, { state: { driver } });
          }}
        >
          <Row className="top-row-driver">
            <div
              className={
                driver.statusText === "Available"
                  ? "available-status"
                  : driver.statusText === "Booked"
                  ? "booked-status"
                  : "warning-status"
              }
            >
              {driver.statusText}
            </div>
            <span className="driver-num">
              <img src={StudentCardImg} />
              <Text
                className="driver-lscNumber"
                style={{ width: "100px" }}
                ellipsis={{ tooltip: true }}
              >
                {driver.drivingLicenseNumber}
              </Text>
            </span>
          </Row>
          <div className="driver-card-row">
            <img src={DriverGruardImg} alt="alt" className="img-size-driver" />
            <div className="driver-detail">
              <Text style={{ width: "100px" }} ellipsis={{ tooltip: true }}>
                {driver.name}
              </Text>
              <span>
                <img src={TruckPhoneImg} />
                <span>
                  {"+"}
                  {driver?.countryCode ? driver?.countryCode : "NA"}{" "}
                  {driver.mobileNumber}
                </span>
              </span>
            </div>
          </div>
          <div
            className={
              driver.statusText === "Available"
                ? "last-update-driver-available"
                : "last-update-driver-warning"
            }
          >
            <Text
              className={
                driver.statusText === "Available"
                  ? "typo-text-available"
                  : "typo-text-warning"
              }
              style={{ width: "14rem" }}
              ellipsis={{ tooltip: true }}
            >
              {driver?.actionableMessage
                ? driver?.actionableMessage
                : "No Action Required"}
            </Text>
            {driver?.actionableMessage && (
              <img
                src={
                  driver?.statusText === "Available"
                    ? NextArrowGreen
                    : NextArrowOrange
                }
                alt="alt"
              />
            )}
          </div>
        </div>
      </Col>
    );
  };

  const truckListTypes = (truckItems, index) => {
    return (
      <>
        {loading && fleetType === "Trucks" && trucks?.length === 0 ? (
          <div className="loading">
            <Spin />
          </div>
        ) : (
          <div className="scroll-continer" key={index}>
            {truckItems?.length > 0 ? (
              <>
                <Row justify="start" gutter={[16, 0]}>
                  {truckItems.map((truck, index) => {
                    return truckCard(truck, index);
                  })}
                </Row>
                {loading && (
                  <div className="loading">
                    <Spin />
                  </div>
                )}
                {hasMoreData && (
                  <div ref={observerRef} className="load-more">
                    {" "}
                    <img src={LoadingImg} alt="loading" /> Loading more trucks..{" "}
                  </div>
                )}
              </>
            ) : (
              <Row justify={"center"} className="no-data">
                <img src={NodataImg} alt="no data" />
              </Row>
            )}
          </div>
        )}
      </>
    );
  };

  const driverListTypes = (driverItems, index) => {
    return (
      <>
        {loading && fleetType === "Drivers" && drivers?.length === 0 ? (
          <div className="loading">
            <Spin />
          </div>
        ) : (
          <div className="scroll-continer-drivers" key={index}>
            {driverItems?.length > 0 ? (
              <>
                <Row gutter={[16, 0]}>
                  {driverItems?.map((driver, index) => {
                    return driverCard(driver, index);
                  })}
                </Row>
                {loading && (
                  <div className="loading">
                    <Spin />
                  </div>
                )}
                {hasMoreData && (
                  <div ref={observerRef} className="load-more">
                    {" "}
                    <img src={LoadingImg} alt="loading" /> Loading more
                    drivers..{" "}
                  </div>
                )}
              </>
            ) : (
              <Row justify={"center"} className="no-data">
                <img src={NodataImg} alt="no data" />
              </Row>
            )}
          </div>
        )}
      </>
    );
  };

  const items = [
    {
      key: "All",
      label: t("FLEET_TRUCKS_ALL"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
    {
      key: "Available",
      label: t("FLEET_TRUCKS_AVAILABLE"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
    {
      key: "DetailsSubmitted",
      label: t("FLEET_TRUCKS_DETAILS_SUBMITTED"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
    {
      key: "Rejected",
      label: t("FLEET_TRUCKS_REJECTED"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
    {
      key: "Expired",
      label: t("FLEET_TRUCKS_EXPIRED"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
    {
      key: "Banned",
      label: t("FLEET_TRUCKS_BANNED"),
      children:
        fleetType === "Trucks"
          ? truckListTypes(trucks)
          : driverListTypes(drivers),
    },
  ];
  function getStringBeforeComma(input) {
    return input.split(",")[0];
  }
  const onClickPageHandler = (page) => {
    if (page === fleetType) return;

    setDrivers([]);
    setTrucks([]);
    setFleetType(page);
    setCurrentTab("All");
    setCurrentPage(1);
    setHasMoreData(true);
    setSearchValue("");
  };

  const onTabChange = (key) => {
    setCurrentTab(key);
    setTrucks([]);
    setDrivers([]);
    setCurrentPage(1);
    setHasMoreData(true);
    setSearchValue("");
  };

  const getSupplierData = () => {
    setLoading(true);
    let payload = {
      pageSize: pageSize,
      pageNumber: currentPage,
      search: "",
      sortBy: "asc",
      sortOrder: "",
      supplierId: supplierId ? supplierId : "",
    };

    supplierService
      .getFleetSupplierList(payload)
      .then((response) => {
        if (response.status == 200) {
          setLoading(false);

          setSupplierData((prevData) => [...prevData, ...response?.data?.data]);
          const userRole = response?.data?.data.find(
            (supplier) => supplier?.supplierId === supplierId
          );
          setUserRole(userRole);

          if (
            response.data.pagination.pageNumber >=
            response.data.pagination.totalPages
          ) {
            setHasMoreData(false);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getOnTripTruckTrackingList = () => {
    setLoading(true);
    let payload = {
      pageSize: pageSize,
      pageNumber: 1,
    };
    fleetTrackService
      .getOnTripTruckTrackingList(payload)
      .then((response) => {
        if (response.status == 200) {
          setLoading(false);
          setOnTripTrackList(response?.data?.data);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getAvailableTruckTrackingList = () => {
    setLoading(true);
    let payload = {
      pageSize: pageSize,
      pageNumber: 1,
    };
    fleetTrackService
      .getAvailableTruckTrackingList(payload)
      .then((response) => {
        if (response.status == 200) {
          setLoading(false);
          setAvailableTrackList(response?.data?.data);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // ******************** OCR HANDLING **********************

  return (
    <div className="fleet-wrapper">
      <Col span={16} className="trucks">
        {checkIsInternalSourcing(user.userRole) && (
          <div className="supplier-details">
            <div className="supplier-name">
              <img src={SupplierdImg} alt="" />
              <span>{supplierName}</span>
            </div>
            <div
              className="supplier-view-details"
              onClick={() => navigate(`/supplier-detail/${supplierId}`)}
            >
              <span>{t("SUPPLIER_FULL_DETAIL_LBL")}</span>
              <img src={NextArrowOrange} alt="" />
            </div>
          </div>
        )}
        <Row className="trucks-space" justify={"space-between"}>
          <Space>
            <Button
              className={fleetType === "Trucks" ? "activeBtn" : "deactiveBtn"}
              onClick={() => onClickPageHandler("Trucks")}
            >
              {" "}
              {t("FLEET_TRUCKS")}
            </Button>
            <Button
              className={fleetType === "Drivers" ? "activeBtn" : "deactiveBtn"}
              onClick={() => onClickPageHandler("Drivers")}
            >
              {t("FLEET_DRIVER")}
            </Button>
          </Space>
          <Space>
            <Input
              placeholder={t("FLEET_SEARCH_PH")}
              prefix={<SearchOutlined />}
              className="search-input"
              onChange={(e) => {
                setSearchValue(e.target.value);
                setDrivers([]);
                setTrucks([]);
                setCurrentPage(1);
              }}
            />
            <Button
              disabled={
                (checkIsSTO(user?.userRole) ||
                  checkIsSTO(location.state?.userRole)) &&
                fleetType === "Drivers"
              }
              className="add-btn"
              onClick={() => setAddModalOpen(!addModalOpen)}
            >
              {t("FLEET_MANAGEMENT_ADD_BTN")}{" "}
              {fleetType === "Drivers" ? t("MYBIDS_DRIVER") : t("LOADS_TRUCK")}
            </Button>
          </Space>
        </Row>
        <>
          {(fleetType === "Trucks" || fleetType === "Drivers") && (
            <>
              <Tabs
                items={items}
                activeKey={currentTab}
                defaultActiveKey="All"
                onChange={onTabChange}
              />
            </>
          )}
        </>
      </Col>
      <Col span={8} className="truck-tracking">
        <Space className="track-title">
          <span>{t("FLEET_TRUCKS_TRUCK_TRACKING")}</span>
          <Button
            icon={<img src={MapButtonIcon} alt="alt" />}
            onClick={() => setMapModalOpen(true)}
          >
            {t("FLEET_TRUCKS_MAP_VIEW")}
          </Button>
        </Space>
        <div className="trip-detail">
          <p
            onClick={() => setTrackingtype("onTrip")}
            className={trackingType === "onTrip" ? "active" : "in-active"}
          >
            {t("FLEET_TRUCKS_ON_TRIP")}{" "}
            <span className="circle">{onTripTrackList?.length}</span>
          </p>
          <p
            onClick={() => setTrackingtype("available")}
            className={trackingType === "available" ? "active" : "in-active"}
          >
            {t("FLEET_TRUCKS_AVAILABLE")}{" "}
            <span className="circle">{availableTrackList?.length}</span>
          </p>
        </div>
        {trackingType === "onTrip" ? (
          onTripTrackList?.length > 0 ? (
            <div className="truck-list">
              {onTripTrackList?.map((truck) => (
                <div className="cards">
                  <div>
                    <Row justify={"space-between"} className="card-rows-top">
                      <Col className="truck-no">
                        <span>{t("FLEET_TRUCKS_TRUCK_NO")}</span>
                        <Text
                          style={{ width: "100px" }}
                          ellipsis={{ tooltip: true }}
                        >
                          {truck.assetPlateNumber}
                        </Text>
                      </Col>
                      <Col className="truck-item">
                        <Text
                          style={{ width: "100px" }}
                          ellipsis={{ tooltip: true }}
                        >
                          {truck.truckType} {truck.subTruckType}
                        </Text>
                      </Col>
                    </Row>
                    <Row justify={"space-between"} className="card-rows">
                      <Col className="column-span">
                        <span>{t("FLEET_TRUCKS_DRIVER_NAME")}</span>
                        <span className="diff-font-size">
                          {truck.driverName}
                        </span>
                      </Col>
                      <Col className="column-span">
                        <span>{t("FLEET_TRUCKS_CONTACT_NO")}</span>
                        <span
                          className="diff-font-size"
                          style={{
                            color: "var(--text-subtle, #545D69B2)",
                            textDecoration: "underline",
                          }}
                        >
                          + {truck?.driverContactDetails?.countryCode}{" "}
                          {truck?.driverContactDetails?.mobileNumber}
                        </span>
                      </Col>
                    </Row>

                    <div className="bottom-border-trucktrack"></div>

                    <Row justify={"space-between"} className="card-rows">
                      <Col>
                        <a
                          className="truck-id"
                          onClick={() =>
                            navigate(
                              `/orders/${truck?.orderNumber}/${truck?.tripId}/${truck?.assetPlateNumber}-${truck?.driverName}`
                            )
                          }
                        >
                          {truck.orderNumber}
                        </a>
                      </Col>
                      {truck.tripStatus && (
                        <Col className="stage">{truck.tripStatus}</Col>
                      )}
                    </Row>
                    <Row
                      justify={"space-between"}
                      className="truck-tracking-row"
                    >
                      <Col className="column-span">
                        <span>From</span>
                        <span className="diff-font-size">
                          {getStringBeforeComma(truck.fromCity)}
                        </span>
                      </Col>
                      <Col className="column-span">
                        <span>To</span>
                        <span className="diff-font-size">
                          {getStringBeforeComma(truck.toCity)}
                        </span>
                      </Col>
                    </Row>
                    <div className="bottom-border-trucktrack"></div>
                    <Row justify={"space-between"} className="card-rows">
                      <Col>
                        <span className="location-span">
                          <img src={currentLocation} alt="alt" />{" "}
                          {t("FLEET_TRUCKS_CURRENT_LOCATION")}:{" "}
                          {truck?.currentLocation?.location}
                        </span>
                      </Col>
                      <Col>
                        <span className="location-span">
                          <img src={movingCircle} alt="alt" />{" "}
                          {t("TRACKING_MOVING_SINCE")}{" "}
                          {truck?.tripStartedOn
                            ? moment().diff(
                                moment(truck?.tripStartedOn),
                                "days"
                              )
                            : "0"}{" "}
                          {t("TRACKING_MOVING_DAYS")}
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <Row className="last-update-track">
                    {" "}
                    <img src={clockImg} alt="alt" />{" "}
                    {t("FLEET_TRUCKS_LAST_UPDATED")}:{" "}
                    {truck?.locationLastUpdatedTimeStamp
                      ? moment
                          .utc(truck.locationLastUpdatedTimeStamp)
                          .format("DD MMM YYYY, h:mm A")
                      : "NA"}
                  </Row>
                </div>
              ))}
            </div>
          ) : (
            <Row justify={"center"} className="no-data">
              <img src={NodataImg} alt="no data" />
            </Row>
          )
        ) : availableTrackList?.length > 0 ? (
          <div className="truck-list">
            {availableTrackList?.map((truck) => (
              <div className="cards">
                <div>
                  <Row justify={"space-between"} className="card-rows">
                    <Col className="truck-no">
                      <span>{t("FLEET_TRUCKS_TRUCK_NO")}</span>
                      <span>{truck.assetPlateNumber}</span>
                    </Col>
                    <Col className="truck-item">
                      {truck.truckType} {truck.subTruckType}
                    </Col>
                  </Row>

                  <div className="bottom-border"></div>
                  <Row justify={"space-between"} className="card-rows">
                    <Col>
                      <span className="location-span">
                        <img src={currentLocation} alt="alt" />{" "}
                        {t("FLEET_TRUCKS_CURRENT_LOCATION")}:{" "}
                        {truck?.currentLocation?.location}
                      </span>
                    </Col>
                  </Row>
                </div>
                <Row className="last-update-track">
                  {" "}
                  <img src={clockImg} alt="alt" />{" "}
                  {t("FLEET_TRUCKS_LAST_UPDATED")}:{" "}
                  {truck?.locationLastUpdatedTimeStamp
                    ? moment
                        .utc(truck?.locationLastUpdatedTimeStamp)
                        .format("DD MMM YYYY, h:mm A")
                    : "NA"}
                </Row>
              </div>
            ))}
          </div>
        ) : (
          <Row justify={"center"} className="no-data">
            <img src={NodataImg} alt="no data" />
          </Row>
        )}
      </Col>
      {mapModalOpen && (
        <CustomMapModal
          isOpen={mapModalOpen}
          setMapModalOpen={setMapModalOpen}
          markers={
            trackingType === "onTrip" ? onTripTrackList : availableTrackList
          }
          typeData={trackingType === "onTrip" ? "On Trip" : "Available Trucks"}
        />
      )}
      {addModalOpen && fleetType === "Trucks" && (
        <AddTruck
          isOpen={addModalOpen}
          onClose={handleCloseModal}
          refresh={getData.bind(this)}
          setTrucks={setTrucks}
          supplierId={supplierId}
          supplierCountry={
            checkIsInternalSourcing(user?.userRole)
              ? location?.state?.operatingCountry
              : ""
          }
          // OCR MODULE PROPS
          setIsUploadingPopupVisible={setIsUploadingPopupVisible}
          setUploadState={setUploadState}
          setSamplePreviewOpen={setSamplePreviewOpen}
          setSampleType={setSampleType}
        />
      )}
      {addModalOpen && fleetType === "Drivers" && (
        <AddDriver
          isOpen={addModalOpen}
          onClose={handleCloseModal}
          refresh={getData.bind(this)}
          setDrivers={setDrivers}
          supplierId={supplierId}
          // OCR MODULE PROPS
          setIsUploadingPopupVisible={setIsUploadingPopupVisible}
          setUploadState={setUploadState}
          setSamplePreviewOpen={setSamplePreviewOpen}
          setSampleType={setSampleType}
          setCountryCodeName={setCountryCodeName}
        />
      )}

      <Modal
        open={isUploadingPopupVisible}
        footer={null}
        closable={false}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        width={352}
        style={{
          textAlign: "center",
          padding: "32px 16px",
          zIndex: "2000000 !important",
          position: "relative",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "1.5",
            margin: 0,
          }}
        >
          {t("OCR_MODAL_UPLOADING_PROCESSING_DOC")}
        </h3>
        <div style={{ margin: "12px 0" }}>
          <img
            // src={logo}
            src={fileSearchGif}
            alt="File Search"
            style={{ width: 112, height: 112 }}
          ></img>
        </div>

        <p
          style={{
            fontWeight: "500",
            fontSize: "14px",
            margin: 0,
            color: "var(--text-muted, #2C3A4BE5)",
          }}
        >
          {uploadState.status}
        </p>
        <p
          style={{
            color: "var(--text, #394452)",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: 0,
            color: "var(--text-muted, #394452CC)",
          }}
        >
          {uploadState.description}
        </p>
      </Modal>

      {/* Sample Document View Modal */}
      <Modal
        open={isSamplePreviewOpen}
        footer={null}
        closable={false}
        centered
        style={{ zIndex: "20000 !important", position: "relative" }}
      >
        <SampleDocumentPreviewModal
          sampleType={sampleType}
          countryCodeName={countryCodeName || "AE"}
          onClose={() => setSamplePreviewOpen(false)}
        />
      </Modal>
    </div>
  );
};

export default Fleet;
